﻿let LuminateSession = require('./LuminateSession');
let Q = require('q');

module.exports = UserSession;

function UserSession() {
    this.luminateSession = new LuminateSession();
}

UserSession.prototype = {
    signIn(loginData) {
        return this.signInToSitefinity(loginData).then(result => {
            if (result.Result === 0) {
                return this.luminateSession.assertOpen();
            } else {
                throw result;
            }
        });
    },

    signOut() {
        return this.luminateSession.closeLuminateSession()
            .then(() => this.signOutFromSitefinity());
    },

    syncSession() {
        return this.luminateSession.isSessionOpen()
            .then(isOpen => isOpen ? null : this.signOutFromSitefinity());
    },

    signOutFromSitefinity() {
        return Q($.ajax({
            type: 'POST',
            url: jnfroutesconfg.LogoutUrl,
            xhrFields: { withCredentials: true }
        }));
    },

    signInToSitefinity(loginData) {
        return Q($.ajax({
            type: 'POST',
            url: jnfroutesconfg.LoginUrl,
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(loginData),
            xhrFields: { withCredentials: true }
        }));
    }
}